import { compose, withHandlers, lifecycle, withState } from 'recompose'
import { connect } from 'react-redux'
import _get from 'lodash/get'
import { reduxForm } from 'redux-form'
import { withRouter } from 'react-router-dom'
import { analytics } from 'services/Analytics'
import { ROUTES } from 'constants/routes'
import { ALERTS } from 'constants/alerts'
import { ERROR_CODES } from 'constants/errors'
import { SUBSCRIPTION_STATUS } from 'constants/subscription'
import { withLocalization } from 'hocs/localization'
import { onChangeSubscriptionPlan } from 'redux-app/actionCreators/subscription'
import { getChangeSubscriptionTerms } from 'api/client/actions/subscriptions'
import { getSelectedPlanId, getSubscriptionPlans } from 'redux-app/selectors/subscription'
import { getSubscriptionStatus, getUserSubscription } from 'redux-app/selectors/user'
import { createAlert, onShowError } from 'redux-app/modules/alerts'
import { getErrorCodes } from 'utils/error'
import { FIELD_NAMES } from './constants'
import Terms from './Terms'

export default compose(
  withLocalization('profile.planChoose.terms'),
  connect(
    state => ({
      activePlanId: _get(getUserSubscription(state), 'planId'),
      plans: getSubscriptionPlans(state).sort((a, b) => a.price > b.price ? 1 : -1),
      subscriptionStatus: getSubscriptionStatus(state),
      selectedPlanId: getSelectedPlanId(state),
    }),
    {
      onChangeSubscriptionPlan,
      getChangeSubscriptionTerms,
      createAlert,
      onShowError,
    },
  ),
  withRouter,
  withHandlers({
    changePlan: ({
      plans,
      createAlert,
      history,
      selectedPlanId,
      subscriptionStatus,
      activePlanId,
      onChangeSubscriptionPlan,
    }) => formValues => {
      const newPlan = plans.find(plan => plan.id === selectedPlanId)
      return onChangeSubscriptionPlan(selectedPlanId, formValues[FIELD_NAMES.customerSignature])
        .then(() => {
          const oldPlan = plans.find(plan => plan.id === activePlanId)
          if (newPlan.price > oldPlan.price) {
            analytics.upgradePlan({ planName: newPlan.name })
          } else {
            analytics.downgradePlan({ planName: newPlan.name })
          }
          if (subscriptionStatus === SUBSCRIPTION_STATUS.pendingConfirmation) {
            history.replace(ROUTES.profile.view)
            createAlert({ name: ALERTS.successChangeSubscription })
            return
          }
          history.push(ROUTES.profile.changePlan.newPlanAccepted)
        })
    },
  }),
  reduxForm({
    form: 'acceptTerms',
  }),
  withState('data', 'setData', null),
  withState('isLoading', 'setLoadingStatus', true),
  lifecycle<any, any>({
    componentDidMount () {
      window.scrollTo(0, 0)
      analytics.openCreateReviewTermsPage()
      this.props.getChangeSubscriptionTerms(this.props.selectedPlanId)
        .then(({ value: { result } }) => {
          this.props.setData(result.fields)
          this.props.setLoadingStatus(false)
        })
        .catch(error => {
          const errorCodes = getErrorCodes(error)
          if (errorCodes.includes(ERROR_CODES.sabrixNotAvailable)) {
            this.props.createAlert({ name: ALERTS.error })
            return
          }
          this.props.setLoadingStatus(false)
          this.props.onShowError(error)
        })
    },
  }),
  withRouter,
)(Terms)
